export const regionKeys = {
  all: ['regions'] as const,
  lists: () => [...regionKeys.all, 'list'] as const,
  list: (
    page: number,
    pageSize: number,
    searchTerm?: string,
    isActive?: boolean,
    countryIds?: string[],
    selector?: number,
    parentId?: string,
    getAllLevels?: boolean,
  ) =>
    [
      ...regionKeys.lists(),
      page,
      pageSize,
      searchTerm,
      isActive,
      countryIds,
      selector,
      parentId,
      getAllLevels,
    ] as const,
  defaultList: () =>
    [
      ...regionKeys.lists(),
      1,
      10,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    ] as const,
  details: () => [...regionKeys.all, 'detail'] as const,
  detail: (id: string) => [...regionKeys.details(), id] as const,
  byCountryAndType: (countryIds?: string[], selector?: number) =>
    [...regionKeys.all, 'byCountryAndType', countryIds, selector] as const,
  // Shorter prefix (no trailing undefined args) so invalidateQueries partial-matches every
  // cached byCountryAndType(...) variant — TanStack's partial match requires the filter key
  // to be an actual prefix, and `undefined` in a slot does NOT match a defined value there.
  byCountryAndTypeAll: () => [...regionKeys.all, 'byCountryAndType'] as const,
  tree: () => [...regionKeys.all, 'tree'] as const,
};
